import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AuthMiddleware from "./AuthMiddleware";
import AuditCompleted from "./Pages/AuditCompleted";
import AuditPlanning from "./Pages/AuditPlanning";
import AuditOverview from "./Pages/AuditOverview";
import AuditReview from "./Pages/AuditReview";
import CreateAuditPlanning from "./Pages/CreateAuditPlanning";
import UpdateAuditPlanning from "./Pages/UpdateAuditPlanning";
import Dashboard from "./Pages/Dashboard";
import Analytics from "./Pages/AuditAnalyticschart";
import Login from "./Pages/Login";
import ManageUsers from "./Pages/ManageUsers";
import UserManagement from "./Pages/UserManagement";
import RoleMapping from "./Pages/RoleMapping";
import SelectQuestions from "./Pages/SelectQuestions";
import ViewAuditing from "./Pages/ViewAuditing";
import ComingSoon from "./Pages/ComingSoon";
import PolicyComparison from "./Pages/PolicyComparison";
import AuditOverviewGraph from "./Pages/AuditOverviewGraph";
import LLMConfig from "./Pages/LLMConfig";
import PrivateRoute from "./PrivateRoute";
import AIInteractionConfiguration from "./Pages/AIInteractionConfiguration";
import LDAPConfig from "./Pages/LDAPConfig";

const AppRouter: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AuthMiddleware element={Login} />} />
        <Route path="/login" element={<AuthMiddleware element={Login} />} />
        <Route
          path="/overview/audit-overview"
          element={<PrivateRoute element={AuditOverviewGraph} />}
        />
        <Route
          path="/audit-overview"
          element={<PrivateRoute element={AuditOverview} />}
        />
        <Route
          path="/policy-comparison"
          element={<PrivateRoute element={PolicyComparison} />}
        />
        <Route
          path="/audit-scheduled"
          element={<PrivateRoute element={AuditPlanning} />}
        />
        <Route
          path="/in-progress"
          element={<PrivateRoute element={AuditReview} />}
        />
        <Route
          path="/closure"
          element={<PrivateRoute element={AuditCompleted} />}
        />
        <Route
          path="/audit-scheduled/select-question/:id/:auditlevel/:audittype"
          element={<PrivateRoute element={SelectQuestions} />}
        />
        <Route
          path="/:routeName/review-details/:id"
          element={<PrivateRoute element={ViewAuditing} />}
        />

        <Route path="/home" element={<PrivateRoute element={Dashboard} />} />

        <Route
          path="/audit-overview/add"
          element={<PrivateRoute element={CreateAuditPlanning} />}
        />
        <Route
          path="/audit-scheduled/edit/:id"
          element={<PrivateRoute element={UpdateAuditPlanning} />}
        />
        <Route
          path="/scheduled/edit/:id"
          element={<PrivateRoute element={UpdateAuditPlanning} />}
        />

        <Route path="/users" element={<PrivateRoute element={ManageUsers} />} />
        <Route
          path="/administration/usermanagement"
          element={<PrivateRoute element={UserManagement} />}
        />
        <Route
          path="/administration/role-mapping"
          element={<PrivateRoute element={RoleMapping} />}
        />

        <Route
          path="/settings/ldap"
          element={<PrivateRoute element={LDAPConfig} />}
        />
        <Route
          path="/settings/llm-Configuration"
          element={<PrivateRoute element={LLMConfig} />}
        />
        <Route
          path="/:dashboardName/ComingSoon"
          element={<PrivateRoute element={ComingSoon} />}
        />
        <Route
          path="/audit-analytics"
          element={<PrivateRoute element={Analytics} />}
        />
         <Route
          path="/settings/aiinteractionconfiguration"
          element={<PrivateRoute element={AIInteractionConfiguration} />}
        />
      </Routes>
    </Router>
  );
};

export default AppRouter;
